import { Directive, ElementRef, HostListener, Input, OnDestroy, OnInit, Renderer2, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appTooltip]',
  standalone: true
})
export class TooltipDirective implements OnInit, OnDestroy {
  @Input('appTooltip') template!: TemplateRef<any>;
  private tooltip!: HTMLElement;
  timeoutId!: any;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private viewContainerRef: ViewContainerRef
  ) {}

  ngOnInit() {
    this.tooltip = this.renderer.createElement('div');
    this.renderer.addClass(this.tooltip, 'tooltip-directive');
    this.renderer.appendChild(
      this.tooltip,
      this.viewContainerRef.createEmbeddedView(this.template).rootNodes[0]
    );

    this.renderer.appendChild(this.el.nativeElement, this.tooltip);
    this.renderer.setStyle(this.tooltip, 'display', 'none');
    this.renderer.setStyle(this.el.nativeElement, 'position', 'relative');
  }

  ngOnDestroy() {
    this.renderer.removeChild(this.el.nativeElement, this.tooltip);
  }

  @HostListener('mouseenter') onMouseEnter() {
    this.timeoutId = setTimeout(() => {
      this.renderer.setStyle(this.tooltip, 'display', 'block');
    }, 500);
  }

  @HostListener('mouseleave') onMouseLeave() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    this.renderer.setStyle(this.tooltip, 'display', 'none');
  }
}